export default __webpack_public_path__ + "static/media/hotDrink2.b0d2ca63.jpg";